export let declOfNum = ( number, titles ) => titles[ (number%100>4 && number%100<20)? 2 : ([2, 0, 1, 1, 1, 2])[(number%10<5)?number%10:5] ]

export let average = list => ( list.reduce( ( sum, current ) => sum + current, 0 ) / list.length )

export const toMoney = value => `${parseFloat( value ).formatMoney(2, '.', ' ')}`.replace( '.00', '' )